module.exports = __webpack_public_path__ + "static/media/transit_inactive.cdd50d5a.svg";